"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoDataError = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var bubbleAlignPoints = [{ align: "bc tc", offset: { x: 0, y: 0 } }];
exports.NoDataError = function (_a) {
    var fullContent = _a.fullContent;
    return (react_1.default.createElement("div", { className: "gd-visualization-content visualization-empty" },
        react_1.default.createElement("div", { className: "info-label info-label-empty" }, fullContent ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "info-label-icon-empty" }),
            react_1.default.createElement(sdk_ui_kit_1.Typography, { tagName: "p" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "visualization.empty.headline", tagName: "span" })))) : (react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, null,
            react_1.default.createElement("div", { className: "info-label-icon-empty" }),
            react_1.default.createElement(sdk_ui_kit_1.Bubble, { alignPoints: bubbleAlignPoints },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "visualization.empty.headline", tagName: "span" })))))));
};
//# sourceMappingURL=NoDataError.js.map